// extracted by mini-css-extract-plugin
module.exports = {"socialContainer":"_social_socialContainer_1DWHh","shareIcon":"_social_shareIcon_RMOGb"};